import { render, staticRenderFns } from "./FormButtonLoadBreeds.vue?vue&type=template&id=343234b5&"
import script from "./FormButtonLoadBreeds.vue?vue&type=script&lang=js&"
export * from "./FormButtonLoadBreeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports